export default {"src":"/_next/static/media/sumo.8586b7e2.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};